"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformApiDataToHotelPrices = exports.isToday = exports.getPriceStyle = exports.generateDates = exports.formatDate = exports.buildHotelQueryParams = void 0;
var _constants = require("./constants");
var generateDates = (startDate, days) => {
  var result = [];
  var baseTime = startDate.getTime();
  for (var i = 0; i < days; i++) {
    var currentDate = new Date(baseTime + i * 24 * 60 * 60 * 1000);
    result.push(currentDate.toISOString().split('T')[0]);
  }
  return result;
};
exports.generateDates = generateDates;
var formatDate = (isoDate, options) => {
  var {
    isSmallerThanSm = false,
    locale = 'en-GB'
  } = options || {};
  var date = new Date(isoDate);
  if (isNaN(date.getTime())) {
    return {
      weekday: '',
      day: ''
    };
  }
  var dtfOptions = {
    weekday: 'short',
    day: 'numeric',
    month: 'short'
  };
  try {
    var _parts$find, _parts$find2, _parts$find3;
    var parts = new Intl.DateTimeFormat(locale, dtfOptions).formatToParts(date);
    var weekday = ((_parts$find = parts.find(p => p.type === 'weekday')) === null || _parts$find === void 0 ? void 0 : _parts$find.value) || '';
    var day = ((_parts$find2 = parts.find(p => p.type === 'day')) === null || _parts$find2 === void 0 ? void 0 : _parts$find2.value) || '';
    var month = ((_parts$find3 = parts.find(p => p.type === 'month')) === null || _parts$find3 === void 0 ? void 0 : _parts$find3.value) || '';
    if (isSmallerThanSm) {
      weekday = weekday.slice(0, 2);
    }
    month = month.slice(0, 3);
    var isFirstDayOfMonth = date.getDate() === 1;
    var monthToReturn = isFirstDayOfMonth ? month : undefined;
    return {
      weekday,
      day,
      month: monthToReturn
    };
  } catch (error) {
    return {
      weekday: '',
      day: ''
    };
  }
};
exports.formatDate = formatDate;
var isToday = dateString => {
  var today = new Date().toISOString().split('T')[0];
  return dateString === today;
};
exports.isToday = isToday;
var getPriceStyle = exports.getPriceStyle = function getPriceStyle(price, lowestPriceForComparison) {
  var highlightedPriceRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  if (!price) return {
    textBg: 'transparent',
    color: _constants.THEME_COLORS.disabledColor,
    fontWeight: 500
  };
  if (!lowestPriceForComparison) return {
    textBg: 'transparent',
    color: 'black',
    fontWeight: 500
  };
  if (price === lowestPriceForComparison) {
    return {
      textBg: _constants.THEME_COLORS.lowestPrice,
      color: 'black',
      fontWeight: 500
    };
  }
  if (price <= lowestPriceForComparison + highlightedPriceRange) {
    return {
      textBg: _constants.THEME_COLORS.nearLowestPrice,
      color: 'black',
      fontWeight: 500
    };
  }
  return {
    textBg: 'transparent',
    color: 'black',
    fontWeight: 500
  };
};
var transformApiDataToHotelPrices = (apiData, currentDates) => {
  return apiData.map(hotel => {
    var _hotel$links;
    return {
      hotelId: hotel.hotelCode,
      hotelName: hotel.hotelName,
      hotelLink: (_hotel$links = hotel.links) === null || _hotel$links === void 0 ? void 0 : _hotel$links.detailsPage,
      prices: currentDates.map(date => {
        var _hotel$availabilities;
        var availability = (_hotel$availabilities = hotel.availabilities) === null || _hotel$availabilities === void 0 ? void 0 : _hotel$availabilities.find(avail => avail.availableDate === date);
        return {
          date,
          amount: availability !== null && availability !== void 0 && availability.minimumRate && availability.minimumRate > 0 ? availability.minimumRate : null,
          currency: (availability === null || availability === void 0 ? void 0 : availability.currency) || 'GBP'
        };
      })
    };
  });
};
exports.transformApiDataToHotelPrices = transformApiDataToHotelPrices;
var buildHotelQueryParams = selectedDate => {
  var date = new Date(selectedDate);
  var day = String(date.getDate()).padStart(2, '0');
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var year = String(date.getFullYear());
  var params = new URLSearchParams({
    ARRdd: day,
    ARRmm: month,
    ARRyyyy: year,
    NIGHTS: '1',
    ROOMS: '1',
    ADULT1: '1',
    CHILD1: '0',
    COT1: '0',
    INTTYP1: 'DB'
  });
  return params.toString();
};
exports.buildHotelQueryParams = buildHotelQueryParams;